import { render, staticRenderFns } from "./tutorial.vue?vue&type=template&id=5d02b532&scoped=true&"
import script from "./tutorial.vue?vue&type=script&lang=js&"
export * from "./tutorial.vue?vue&type=script&lang=js&"
import style0 from "./tutorial.vue?vue&type=style&index=0&id=5d02b532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d02b532",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentCross: require('/var/www/mbm.garena.all/frontend/components/tutorial/ContentCross.vue').default,ContentHtml: require('/var/www/mbm.garena.all/frontend/components/tutorial/ContentHtml.vue').default})
